import React from 'react'
import { Col, Select } from 'core/components/ui'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import { InputWrapper, InterTitle, StyledSelect } from '../../styled'

const { Option } = Select

const FormItem = ({ setTradeIn, tradeIn, vehicle, trailerHitches, loading }) => {
  const intl = useIntl()
  const { trailerHitch } = vehicle

  const handleChange = value => {
    const extendedVehicle = { ...vehicle, trailerHitch: Number(value) }

    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  const ManualSelect = props => (
    <StyledSelect
      {...props}
      getPopupContainer={triggerNode =>
        triggerNode && triggerNode.parentElement ? triggerNode.parentElement : document.body
      }
    />
  )

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 12 }}>
      <InterTitle id="globaldealer-title-de-1">
        <FormattedMessage id="tradeIn-historical-subtitle-5" />
      </InterTitle>
      <InputWrapper>
        <ManualSelect
          id={intl.formatMessage({
            id: 'select_a_value'
          })}
          placeholder={intl.formatMessage({
            id: 'select_a_value'
          })}
          loading={loading}
          disabled={loading}
          onChange={handleChange}
          value={trailerHitch ? String(trailerHitch) : undefined}
          optionLabelProp="label"
        >
          {trailerHitches &&
            trailerHitches.map(item => (
              <Option value={item.key} key={item.key} label={item.value}>
                {item.value}
              </Option>
            ))}
        </ManualSelect>
      </InputWrapper>
    </Col>
  )
}

FormItem.defaultProps = {
  trailerHitches: [],
  loading: true
}

FormItem.propTypes = {
  id: PropTypes.string,
  vehicle: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: PropTypes.any.isRequired,
  trailerHitches: PropTypes.array,
  loading: PropTypes.bool
}

export default { FormItem }
